<!--  -->
<template>
  <div>
    <div class="select_box">
      <div>
        <div class="outerLayer_groupingArea">
          <div class="left">
            <span class="left_title">是否公用</span>
            <ul class="left_ul">
              <li class="ul_li" :class="{active:pageIfon.is_public == 2}" @click="lewrurl(2)">是</li>
              <li class="ul_li" :class="{active:pageIfon.is_public == 1}" @click="lewrurl(1)">否</li>
            </ul>
          </div>
          <!-- <div class="right">
        <span class="right_span">新建</span>
        <span class="right_span">管理</span>
      </div> -->
        </div>
        <div class="outerLayer_groupingArea" style="margin-bottom:20px">
          <div class="left">
            <span class="left_title">图片类型</span>
            <ul class="left_ul">
              <li
                v-for="itemr,index in typelist"
                :key="index"
                :class="{active:pageIfon.business_type == itemr.type}"
                class="ul_li"
                @click="wrw(itemr.type)"
              >{{ itemr.name }}</li>
            </ul>
          </div>
          <!-- <div class="right">
        <span class="right_span">新建</span>
        <span class="right_span">管理</span>
      </div> -->
        </div>
      </div>
      <div class="updata_box">
        <!-- <el-button type="success" size="small" @click="$refs.file.click()">上传<input ref="file" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="uploadPictures"></el-button> -->
        <div>
          <el-upload
            ref="upload"
            class="upload-demo"
            :file-list="fileList"
            action="#"
            :on-success="handleAvatarSuccess"
            :http-request="httpRequest"
            :before-upload="beforeAvatarUpload"
            :on-remove="handleRemove"
            :multiple="true"
            :on-change="handleChange"
            :show-file-list="false"
            :limit="100"
          >
            <el-button
              size="small"
              type="primary"
              plain
            >点击上传</el-button>
          </el-upload>
          <canvas
            id="mycanvas"
            style="display: none"
          />
        </div>
      </div>
    </div>

    <div v-if="imgarrs.length!=0" class="imgbox">
      <div v-for="(item,index) in imgarrs" :key="index" class="imgboxew">
        <img :src="item.path" class="item-img" @click="handitem(item)">
      </div>
    </div>
    <div v-else class="zanewr">暂无数据</div>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>

</template>

<script>
import { getMaterialLibraryList, materialroadtype, newMateriallist } from '@/api/sourceMaterial.js'
import { getQcConfig, storeBatchQc } from '@/api/sourceminiprogram.js'
import getNowDate from '@/utils/mixins/convertToHump.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { uploadFilesimg } from '@/utils/ObjectStorage.js'
// import { qiniuToken } from '@/api/qiniuToken.js'
// import * as qiniu from 'qiniu-js'
export default {
  components: {
    PaginationRight
  },
  mixins: [getNowDate],
  props: {
    imgarr: {
      type: Array,
      default: () => {
        return []
      }
    }

  },
  data() {
    return {
      imgarrs: [],
      typer: null,
      total: null,
      pageIfon: {
        type: 1,
        page: 1,
        pageSize: 10,
        is_public: 1,
        business_type: 0
      },
      type: null,
      typelist: [],
      obj: {
        business_type: null
      },
      token: null,
      temporary: null,
      options: {
        quality: 0.62,
        noCompressIfLarger: false,
        maxWidth: 2000,
        maxHeight: 2000
      },
      yuanoptions: {
        quality: 1,
        noCompressIfLarger: false
      },
      fileList: [],
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    // 获取token
    // async getQiniuToken() {
    //   const data = await qiniuToken()
    //   this.token = data.data.upToken
    // },
    async getconfig() {
      const res = await getQcConfig()
      this.config = res.data
    },
    // 获取素材库类型列表
    async mawlist() {
      const data = await materialroadtype(this.obj)
      this.typelist = data.data
      console.log('类型data', data)
    },
    send(val, businesstype) {
      this.type = val
      console.log('val', val)
      // this.pageIfon.business_type = businesstype
      // eslint-disable-next-line eqeqeq
      if (businesstype == 16) {
        this.pageIfon.business_type = businesstype
        this.obj.business_type = 16
      } else {
        this.pageIfon.business_type = 0
        this.obj.business_type = 0
      }
      this.getlist()
      this.mawlist()
      // this.getQiniuToken()
      this.getconfig()
    },
    handitem(img) {
      console.log(img, 'img--------')
      // eslint-disable-next-line eqeqeq
      if (this.type == 1) {
        this.$emit('clickicongon', img)
      } else {
        this.$emit('clickicon', img)
      }

      console.log(img)
    },
    // 获取素材库列表
    getlist() {
      getMaterialLibraryList(this.pageIfon).then(res => {
        console.log('res', res)
        this.imgarrs = res.data.list
        this.total = res.data.total
      })
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.getlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.getlist()
    },
    lewrurl(id) {
      this.pageIfon.page = 1
      this.pageIfon.is_public = id
      this.getlist()
    },
    wrw(id) {
      this.pageIfon.page = 1
      this.pageIfon.business_type = id
      this.getlist()
    },
    async uploadPictures(e) {
      const that = this
      const arr = []
      for (let i = 0; i < e.target.files.length; i++) {
        const fileIfon = e.target.files[i]
        const img = new Image()
        const temporary = e.target.files.length > 1 ? '多张' : window.URL.createObjectURL(fileIfon)
        temporary !== '多张' && (img.src = temporary)
        this.temporary = temporary
        this.getImage(temporary).then(r => {
          // console.log(r.height, r.width)

          const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
          const extension = ftype === '.jpg'
          const extension2 = ftype === '.png'
          const extension3 = ftype === '.jpeg'
          const extension4 = ftype === '.gif'
          // eslint-disable-next-line eqeqeq
          if (!extension && !extension2 && !extension3 && !extension4) {
            this.$message({
              message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
              type: 'error'
            })
            return
          }
          if (ftype !== '.gif') {
            console.log('r.height', r.height)
            qiniu.compressImage(fileIfon, r.height >= 2000 ? this.yuanoptions : this.options).then(data => {
            // const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '--' + fileIfon.name}`, this.token, {
              const observable = qiniu.upload(data.dist, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
                fname: fileIfon.name // 文件名
              }, {
                useCdnDomain: true // cdn域名加速
              })
              observable.subscribe({
                next() { },
                error(err) {
                  console.log(err)
                },
                complete: (data) => {
                  arr.push({
                    type: 1,
                    height: img.height,
                    width: img.width,
                    size: fileIfon.size,
                    key: data.key
                  })
                  if (arr.length === e.target.files.length) {
                  // this.$refs.men.style.height = 0
                    setTimeout(async() => {
                      await newMateriallist({ list: arr, business_type: that.pageIfon.business_type, is_public: that.pageIfon.is_public })
                      await this.getlist()
                      this.temporary = null
                    }, 500)
                  // console.log(arr)
                  }
                }

              })
            })
          } else {
          // const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '--' + fileIfon.name}`, this.token, {
            const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
              fname: fileIfon.name // 文件名
            }, {
              useCdnDomain: true // cdn域名加速
            })
            observable.subscribe({
              next() { },
              error(err) {
                console.log(err)
              },
              complete: (data) => {
                arr.push({
                  type: 1,
                  height: img.height,
                  width: img.width,
                  size: fileIfon.size,
                  key: data.key
                })
                if (arr.length === e.target.files.length) {
                // this.$refs.men.style.height = 0
                  setTimeout(async() => {
                    await newMateriallist({ list: arr, business_type: that.pageIfon.business_type, is_public: that.pageIfon.is_public })
                    await this.getlist()
                    this.temporary = null
                  }, 500)
                // console.log(arr)
                }
              }

            })
          }
        })
      }
    },
    getImage(result) {
      return new Promise(function(resolve, reject) {
        const img = new Image()
        img.src = result
        img.onload = function() { // 注意只有onload以后才可以拿到图片信息
          resolve({
            width: img.width,
            height: img.height
          })
        }
      })
    },
    handleAvatarSuccess(res, file) {
      console.log('res, fil=====e:', res, file)
    },
    beforeAvatarUpload(file) {
      this.uploadFile = file
    },
    handleChange(file, fileList) {
      console.log(1)
      this.uploadedVideoshow = false
      this.uploadedVideoCount++
      this.imgloding = false
      fileList.forEach(info => {
        // eslint-disable-next-line eqeqeq
        // if (file.uid != info.uid) {
        //   this.deletefile(info.raw)
        // }
      })

      if (fileList.length > 0) {
        const existingUIDs = this.fileList.map(info => info.uid)
        const processedFiles = fileList.map(info => {
          return {
            ...info,
            name: info.name && info.name.replace(/\s/g, '') // 名字去除空格
          }
        })
        const newFiles = processedFiles.filter(info => !existingUIDs.includes(info.uid))
        this.fileList.push(...newFiles)
      }
    },
    async httpRequest(e) {
      // console.log('e:', e)
      this.loading = false
      const _this = this
      const fileIfon = e.file
      console.log('fileIfon:', fileIfon)
      const arr = []
      const img = new Image()
      // const videoWidth = 0
      // const videoHeight = 0
      const fileType = fileIfon.type
      console.log('fileType:', fileType)

      if (fileType.startsWith('image/')) {
        // const temporary = e.files.length > 1 ? '多张' : window.URL.createObjectURL(fileIfon)
        // temporary !== '多张' && (img.src = temporary)
        // this.temporary = temporary
        const programimg = window.URL.createObjectURL(fileIfon)
        img.src = programimg
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        console.log('fileIfon.size:', fileIfon.size)
        const maxSize = 20 * 1024 * 1024 // 设置最大文件大小为50MB
        if (fileIfon.size > maxSize) {
          return this.$message('上传图片太大')
        }
        _this.showProgress = true
        this.percentage = 0
        console.log('fileIfon:', fileIfon)
        await uploadFilesimg(
          fileIfon,
          (num, id) => {
            this.percentage = num
          },
          'operation',
          this.config
        )
          .then(res => {
            console.log('res-------:', res.files[0].options)
            // this.ruleForm.chapter_pay_cover = res.files[0].options.Key
            // this.$forceUpdate()
            arr.push({
              type: 1,
              height: img.height,
              width: img.width,
              size: fileIfon.size,
              key: res.files[0].options.Key
            })
            // this.$refs.men.style.height = 0
            setTimeout(async () => {
              await storeBatchQc({ list: arr, business_type: _this.pageIfon.business_type, is_public: this.pageIfon.is_public })
              await this.getlist()
              this.temporary = null
            }, 500)
            // console.log(arr)
            _this.showProgress = false
            this.percentage = 0
            this.getlist()
          })
          .catch(err => {
            console.log('err:-----', err)
          })
      } else {
        this.$message({
          message: '不支持的文件类型',
          type: 'error'
        })
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
.imgbox{
  display: flex;
    flex-wrap: wrap;
}
.item-img{
width: 100%;
 margin-right: 15px;
}
.imgboxew{
  width: 150px;
  height: 150px;
  margin-right: 20px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.active{
  color: skyblue;
}
   .outerLayer_groupingArea{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
        .left{
          display: flex;
          align-items: center;
           .left_title{
              font-size: 13px;
           }
           .left_ul{
             display: flex;
             align-items: center;
             .ul_li{
              list-style-type:none;
              padding: 6px 10px;
              font-size: 13px;
              cursor: pointer;
              border-radius: 6px;
              &:not(.active):hover{
               background-color: rgb(230, 230, 230);
              }
              .active{
                background-color: rgb(202, 202, 202);
              }
             }
           }
        }
        .right{
           .right_span{
             font-size: 12px;
             padding: 6px 10px;
             border-radius: 5px;
             display: inline-block;
             cursor: pointer;
             &:hover{
               background-color: rgb(230, 230, 230);
             }
           }
        }
   }
   .zanewr{
  text-align: center;
  margin: 10px 0px;
}
.select_box{
  display: flex;
  justify-content: space-between;
  // align-items: center;
}
.updata_box{
  padding-right: 54px;
}
</style>
